export default __webpack_public_path__ + "static/media/quobyte.dea4f9b7.svg";